//dependencias
import React, { Component } from 'react';

//componentes
import EvaluacionAction from './habitoActitudes'

class Index extends Component {

    render(){
        return(
            <div>
                <EvaluacionAction />
            </div>
        );
    }

}
export default Index;